import { render, staticRenderFns } from "./ReplyAllButton.vue?vue&type=template&id=5a97517d"
import script from "./ReplyAllButton.vue?vue&type=script&lang=ts"
export * from "./ReplyAllButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports